import { Record } from 'immutable';
import { actionTypes, resetPasswordActions } from './reset-password.actions';
import { Err } from '../../err';
import * as api from '../../api';

export const ResetPasswordState = Record({
  token: api.ApiCallState({}),
  err: null,
});

export const resetPasswordReducer = (initialState = new ResetPasswordState(), action) => {

  var state = initialState.set('token',
    api.apiCallReducer(initialState.get('token'), action, resetPasswordActions));

  switch (action.type) {
    case actionTypes.REDEEM_TOKEN_BEGIN:
      return state.set('err', null);
    case actionTypes.REDEEM_TOKEN_SUCCESS:
      return state.set('err', null)
    case actionTypes.REDEEM_TOKEN_FAILURE:
      return state.set('err', new Err(action.err))
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/acct/password/reset-password.reducer.js